import { Box, Divider, Loader } from '@wix/design-system';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { FeaturesNamespace } from './FeaturesNamespace';
export const PlanFeatures = _ref => {
  var _featuresGridData$nam;
  let {
    productId,
    t,
    Trans,
    onError,
    dataHook
  } = _ref;
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: featuresGridData,
    isLoading,
    isError
  } = PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetFeaturesGrid({
    productIds: [productId],
    ...p3Context
  }, !!productId);
  React.useEffect(() => {
    if (isError) {
      onError == null || onError();
    }
  }, [isError, onError]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      align: "center",
      height: "100%"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    dataHook: dataHook
  }, featuresGridData == null || (_featuresGridData$nam = featuresGridData.namespaces) == null ? void 0 : _featuresGridData$nam.filter(ns => {
    var _ns$features;
    return (_ns$features = ns.features) == null ? void 0 : _ns$features.some(feature => {
      var _feature$values;
      return (_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null ? void 0 : _feature$values.available;
    });
  }).map((ns, index, filtered) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: ns.id
  }, /*#__PURE__*/React.createElement(FeaturesNamespace, {
    namespace: ns,
    productId: productId,
    t: t,
    Trans: Trans
  }), index < filtered.length - 1 && /*#__PURE__*/React.createElement(Divider, {
    key: `divider-${index}`
  }))));
};
//# sourceMappingURL=PlanFeatures.js.map